import { useState, useEffect, useRef } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link, Link as RouterLink, useNavigate, BrowserRouter as Router, Switch, Route, NavLink } from 'react-router-dom';
import { useForm } from "react-hook-form";
import Multiselect from 'multiselect-react-dropdown';
import { toast } from "react-toastify";
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
// @mui  
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box, Modal } from '@mui/material';
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import "bootstrap-icons/font/bootstrap-icons.css";
import '../common.scss';
import * as userActions from "../../actions/userActions";
import * as leadActions from "../../actions/leadActions";
import * as incidentReporteActions from "../../actions/incidentReporteActions";

import AccessDenied from '../common/AccessDenied';

// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

const LoanPaymentAttachments = (props) => {
  const { actions, leadsData, usersData, sourceData, getUserModuleData, masterProfileData, leadStatusData } = props;
  const { register, handleSubmit, formState: { errors }, setValue } = useForm();
  const navigate = useNavigate();
  //   const [allLeads, setAllLeads] = useState([]);


  const [open, setOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [viewModalInfo, setViewModalInfo] = useState([]);
  const [showLeadDetails, setShowLeadDetails] = useState(false);
  const formRef = useRef(null);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedLeadSource, setSelectedLeadSource] = useState([]);
  const [getSelectedLeadStatus, setSelectedLeadStatus] = useState([]);
  const [getSelectedLeadProfile, setSelectedLeadProfile] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  //   const [allLeadSource, setAllLeadSource] = useState([]);


  const [viewModulePermissionStatus, setViewModulePermissionStatus] = useState(false);
  const [userHasPermission, setUserHasPermission] = useState(true);
  const [permissions, setPermissions] = useState([]);
  //   const [allLeadStatusData, setAllLeadStatusData] = useState([]);
  const [allMasterProfiles, setAllMasterProfiles] = useState([]);
  const [legalFormId, setLegalFormId] = useState('person');

  const [userRoleType, setUserRoleType] = useState('');
  const [loggeInUserID, setLoggeInUserID] = useState('');

  const [allLoggedinUserChild, setAllLoggedinUserChild] = useState([]);
  const [isExternalUser, setIsExternalUser] = useState(false);
  const [viewUPIModulePermissionStatus, setViewUPIModulePermissionStatus] = useState(false);
  const [isCamChecked, setIsCamChecked] = useState(false);
  const [allLoanPaymentAttachments, setAllLoanPaymentAttachments] = useState([]);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [pageSizeAttachmentPage, setPageSizeAttachmentPage] = useState(config.ITEMS_PER_PAGE);
  const [currentPageLeadPage, setCurrentPageLeadPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [allLoanPaymentAttachmentsExcel, setAllLoanPaymentAttachmentsExcel] = useState([]);

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [keyword, setKeyword] = useState('');
  const [debitDate1, setDebitDate1] = useState('');
  const [emiAmount1, setEmiAmount1] = useState('');
  const [excelFileBtnHide, setExcelFileBtnHide] = useState(false);
  const [noOfLeadsEntered, setNoOfLeadsEntered] = useState(0);
  const [noOfBureauPulled, setNoOfBureauPulled] = useState(0);
  const [noOfAadharOtpDone, setNoOfAadharOtpDone] = useState(0);
  const [noOfBankStatementUploaded, setNoOfBankStatementUploaded] = useState(0);
  const [noOfFIDraftDone, setNoOfFIDraftDone] = useState(0);
  const [noOfFICompletedDone, setNoOfFICompletedDone] = useState(0);
  const [noOfSendToCredit, setNoOfSendToCredit] = useState(0);

  const [noOfCamSubmitted, setNoOfCamSubmitted] = useState(0);
  const [noOfCamApproved, setNoOfCamApproved] = useState(0);
  const [noOfCamRejected, setNoOfCamRejected] = useState(0);
  const [viewDetailsOpen, setViewDetailsOpen] = useState(false);
  const [selectedLoanPaymentAttachmentID, setSelectedLoanPaymentAttachmentID] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]); 
  const [rows, setRows] = useState(
          selectedRows.map((item) => ({ ...item, bulk_selected: false, bulk_amount: "" }))
        );
  const [isBulkApisEnabled, setIsBulkApisEnabled] = useState(false);      
  const [disableBtn, setDisableBtn] = useState(false);

  const [selectedLedgerID, setSelectedLedgerID] = useState(0);
  const [allLedgersArr, setAllLedgersArr] = useState(false);
  const [allChannelArr, setAllChannelArr] = useState(false);
 
  const [filters, setFilters] = useState({
    username: '',
    start_date: '',
    end_date: ''
  }); 

  useEffect(() => {
    const obj = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestData = encryptData(obj);
    const roleName = localStorage.getItem('authUserRoleName');
    if (roleName !== null) {
      setUserRoleType(roleName);
    }
    const response = actions.getUserModuleData(requestData);
    response.then((result) => {
      if (result.data.success === 1) {
        const permissionsData = result.data.data;
        const hasViewPermissions = permissionsData.find(permission => permission.module_name === 'Leads')?.view_permission;
        setPermissions(permissionsData);
        setViewModulePermissionStatus(hasViewPermissions);
        setUserHasPermission(hasViewPermissions);

        if (Object.prototype.hasOwnProperty.call(result.data, 'user_info') && Object.prototype.hasOwnProperty.call(result.data.user_info[0], 'role_type') && result.data.user_info[0].role_type !== '') {
          setUserRoleType(result.data.user_info[0].role_type);
          // alert(result.data.user_info[0].role_type);
          setLoggeInUserID(result.data.user_info[0].user_id);

          if (result.data.user_info[0].role_type.toLowerCase() === "credit head") {
            setIsCamChecked(true);
          }

        }

        if (Object.prototype.hasOwnProperty.call(result.data, 'user_info') && Object.prototype.hasOwnProperty.call(result.data.user_info[0], 'is_external_user') && result.data.user_info[0].is_external_user !== '' && result.data.user_info[0].is_external_user === "1") {
          setIsExternalUser(true);
        }

        const hasViewUPIPermissions = permissionsData.find(permission => permission.module_name === 'UPI Registration')?.view_permission;
        setViewUPIModulePermissionStatus(hasViewUPIPermissions);
      }
    }).catch((error) => {
      console.error("Promise rejected -  lead list:", error);
    });
  }, [setPermissions, setUserHasPermission, setUserRoleType, setLoggeInUserID, setIsExternalUser]);


  const getOtherDetails = (requestData) => { 
    const response = actions.loanPaymentAttachments(requestData, true); 
      response.then((result) => {  
         console.log(''); 
      }).catch((error) => {
        console.error("Promise rejected - lead list:", error);
      });
  }

  const onSubmit = () => {
    setLoading(true);
    const params = {
      size: pageSizeAttachmentPage,
      offsetPage: currentPageLeadPage,
      username: filters.username,
      start_date: filters.start_date,
      end_date: filters.end_date
    };
    
    const requestData = encryptData(params);
    const response = actions.loanPaymentAttachments(requestData, true);
  
    response.then((result) => {
        if (!result.data.data || result.data.data === '') {
        setExcelFileBtnHide(true);
      } else {
        setExcelFileBtnHide(false);
      }
      setAllLoanPaymentAttachments(result.data.data);
      setTotalRowsCount(result.data.total_count);
      getOtherDetails(requestData);

      setAllLedgersArr(result.data?.allLedgers || []);
      setAllChannelArr(result.data?.allChannel || []);
     
    }).catch((error) => {
      console.error("Promise rejected - lead list:", error);
    });
  };
  
  const handleFilterChange = (data) => {
    setFilters({
      username: data?.username,
      start_date: data?.start_date,
      end_date: data?.end_date
    });
    setCurrentPageLeadPage(1);
  };
  
  useEffect(() => {
    onSubmit();
  }, [filters, currentPageLeadPage, pageSizeAttachmentPage]);
  
  const handlePerRowsChangeAttachmentPage = (newpageSizeAttachmentPage, currentPageLeadPage) => {
    setPageSizeAttachmentPage(newpageSizeAttachmentPage);
    setCurrentPageLeadPage(currentPageLeadPage);
  };
  
  const handlePageChangeAttachmentPage = (page) => {
    setCurrentPageLeadPage(page);
  };

  useEffect(() => {
    // check user is logged-in or not
    const authToken = localStorage.getItem('authToken');
    if (authToken === null) {
      navigate('/login');
    }

    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach(name => {
          caches.delete(name);
        })
      });
    }

    const today = new Date();
    const formattedToday = today.toISOString().split('T')[0];
    const threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(today.getMonth() - 3);
    const formattedThreeMonthsAgo = threeMonthsAgo.toISOString().split('T')[0];

    setValue('start_date', formattedThreeMonthsAgo);
    setValue('end_date', formattedToday);

    let userRoleTypeVal = userRoleType;
    let isCamCheckedVal = isCamChecked;
    const roleName = localStorage.getItem('authUserRoleName');

    if (roleName !== null) {
      setUserRoleType(roleName);
      userRoleTypeVal = roleName;
      if (roleName.toLowerCase() === "credit head") {
        setIsCamChecked(true);
        isCamCheckedVal = true;
      }
    }

    setShowLeadDetails(false);
    if (!showLeadDetails) {
      const obj = {
        // "user_role_type": userRoleTypeVal ,
        "size": pageSizeAttachmentPage,
        "offsetPage": currentPageLeadPage,
      };
      const requestData = encryptData(obj);
      const response = actions.loanPaymentAttachments(requestData);
      response.then((result) => {
        const results = result.data.data;
        const resultArr = Object.keys(results).map((key) => results[key]);
        setAllLoanPaymentAttachments(resultArr);
        setTotalRowsCount(result.data.total_count);
        setLoading(false)
        getOtherDetails(requestData);
        setAllLedgersArr(result.data?.allLedgers || []);
        setAllChannelArr(result.data?.allChannel || []);
      })
    }

    if (Array.isArray(usersData.data)) {
      const extractedData = usersData.data.map(item => {
        return { id: item.user_id, name: item.name };
      });
      const resultArr = Object.values(extractedData);
      setAllUsers(resultArr);
    }

    const objSource = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestSourceData = encryptData(objSource);
    const responseSource = actions.sourceData(requestSourceData, false);
    responseSource.then((result) => {
      if (result.data.success === 1) {
        const results = result.data.data.data
        const filteredResultArr = results.filter((item) => item.status === "1");
        const sortedResultArr = filteredResultArr.sort((a, b) =>
          a.source_of_lead.localeCompare(b.source_of_lead)
        );
        const extractedData = sortedResultArr.map(item => {
          return { id: item.id, name: item.source_of_lead };
        });
        const resultArr = Object.values(extractedData);
      }
    }).catch((error) => {
    });

    const objMasterProfile = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestDataMasterProfile = encryptData(objMasterProfile);
    const responseMasterProfile = actions.masterProfileData(requestDataMasterProfile, false);
    responseMasterProfile.then((result) => {
      if (result.data.success === 1) {
        const results = result.data.data.data;
        const resultArr = Object.keys(results).map((key) => results[key]);
        const filteredResultArr = resultArr.filter((item) => item.status === "1");
        const sortedResultArr = filteredResultArr.sort((a, b) =>
          a.lead_profile_name.localeCompare(b.lead_profile_name)
        );
        const extractedData = sortedResultArr.map(item => {
          return { id: item.id, name: item.lead_profile_name };
        });
        const extractedObject = Object.values(extractedData);
        setAllMasterProfiles(extractedObject);
      }
    }).catch((error) => {
    });

    const objLeadStatus = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestLeadStatusData = encryptData(objLeadStatus);
    const leadStatusResponse = actions.leadStatusData(requestLeadStatusData);
    leadStatusResponse.then((result) => {
      if (result.data.success === 1) {
        const results = result.data.data.data;
        const resultArr = Object.keys(results).map((key) => results[key]);
        const filteredResultArr = resultArr.filter((item) => item.status === "1");
        const sortedResultArr = filteredResultArr.sort((a, b) =>
          a.lead_status.localeCompare(b.lead_status)
        );
        const extractedData = sortedResultArr.map(item => {
          return { id: item.id, name: item.lead_status };
        });
        const extractedObject = Object.values(extractedData);
      }
    }).catch((error) => {
    });
  }, [setAllUsers, setAllMasterProfiles]);

  useEffect(() => {
    const obj = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestData = encryptData(obj);
    const response = actions.getLoggedinUserChild(requestData, false);
    response.then((result) => {
      if (result.data.success === 1) {
        const results = result.data.data.data;
        const extractedData = results.map(item => {
          return { id: item.user_id, name: item.name };
        });
        const resultArr = Object.values(extractedData);
        setAllLoggedinUserChild(resultArr);
      }
    }).catch((error) => { 
    });
  }, [setAllLoggedinUserChild]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  }; 

  const btnViewDetailsHandler = (attachmentId) => {  
        setSelectedLoanPaymentAttachmentID(attachmentId);
        setViewDetailsOpen(true); 
    };

    const handleViewDetailsClose = () => {
        setViewDetailsOpen(false);
    };


    const handlePaymentFormSubmit = (data) => {  

          const selectedLedger = allLedgersArr.filter(item =>
              item.ledger_name === data.ledger_name 
            );
            const ledgrID =  selectedLedger[0]?.ledger_id || 0;
            setSelectedLedgerID(ledgrID);
            
             if (data.date_of_payment.trim() === "") {
                toast.error("Date of payment is required.", {
                    position: "top-right",
                });
            } else if (data.amount.trim() === "") {
                toast.error("Amount is required.", {
                    position: "top-right",
                });
            } else if (data.mode_of_payment.trim() === "") {
                toast.error("Mode of payment is required.", {
                    position: "top-right",
                }); 
               } else if (data.ledger_name.trim() === "") {
                toast.error("Ledger name is required.", {
                    position: "top-right",
                }); 
                
                  } else if (data.channel.trim() === "") {
                toast.error("Channel is required.", {
                    position: "top-right",
                }); 

                  } else if (data.instrumentNo.trim() === "") {
                toast.error("Instrument No is required.", {
                    position: "top-right",
                });  

            } else {  
                const params = { "id": selectedLoanPaymentAttachmentID, "date_of_payment": data.date_of_payment, "amount": data.amount, "mode_of_payment": data.mode_of_payment, "ledger_name": data.ledger_name, "channel": data.channel, "instrumentNo": data.instrumentNo, "ledger_id": ledgrID,'action' : 'add_details'};
    
                const requestData = encryptData(params);
                const response = actions.updatePaymentLoanDetails(requestData, navigate);
                response.then((result) => {
                     if (result.data.success === 1) {
                        toast.success(result.data.message, {
                            position: "top-right",
                        });

                        setSelectedLoanPaymentAttachmentID('');
                        setViewDetailsOpen(false);
                        onSubmit(); 
                     } else {
                        toast.error(result.data.message, {
                            position: "top-right",
                        });
                    }
                }).catch((error) => {
                    toast.error(error, {
                        position: "top-right",
                    });
                });
            }
            }

  const exportToExcel = () => {
    const totalCount = totalRowsCount;
    if (totalCount > 0) {
      const allDataParams = {
        "size": totalCount,
        "offsetPage": 1,
      };
      const requestData = encryptData(allDataParams);
      const response = actions.loanPaymentAttachments(requestData);
      response.then((result) => {
        if (result.data && result.data.success === 1 && result.data.data) {
          const results = result.data.data;
          if (results && typeof results === 'object') {
            const resultArr = Object.keys(results).map((key) => results[key]);
            const columnNameMapping = {
              AgreementNo: 'Agreement No',
              file: 'File',
              createdByName: 'Created By',
              created_date: 'Created ON'
            };
            const mappedData = resultArr.map((row) => {
              const mappedRow = {};
              Object.keys(row).forEach((key) => {
                if ( key !== 'total_count') {
                  const displayName = columnNameMapping[key] || key;
                  mappedRow[displayName] = row[key];
                }
              });
              return mappedRow;
            });
            const ws = XLSX.utils.json_to_sheet(mappedData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Loan Payment Attachments');
            XLSX.writeFile(wb, 'loanPaymentAttachments.xlsx');
          } else {
            console.error("Invalid or empty results object", results);
          }
        } else {
          console.error("No data available for export or response error");
        }
        getOtherDetails(requestData);
      }).catch((error) => {
        console.error("Error fetching all data for export", error);
      });
    } else {
      console.error("Total count is not available or is 0");
    }
  };


  const handleCheckboxChange = (id) => {
        const updated = rows.map((row) => {
          if (row.id === id) {
            return { ...row, bulk_selected: !row.bulk_selected };
          }
          return row;
        });
       
        setRows(updated);

        console.log(" individual change rows = ",updated);
      
        if (selectedRows.includes(id)) {
          setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
        } else {
          setSelectedRows([...selectedRows, id]);
        }
      };
  const handleAmountChange = (id, value) => {
        const updated = rows.map((row) => {
          if (row.id === id) {
            return { ...row, bulk_amount: value };
          }
          return row;
        });
        setRows(updated);
        console.log(" change rows = ",rows);
      };


  const bulkAllcloudRepayments = () => {
     const params = {'selectedRows' : selectedRows,
                    'isBulkApisEnabled' : isBulkApisEnabled,
                    'action' : 'payment'
                };  
    
        const requestData = encryptData(params);
        const response = actions.updatePaymentLoanDetails(requestData, navigate);

        response.then((result) => {
              if (result.data.success === 1) {
                toast.success(result.data.message, {
                    position: "top-right",
                });

                setSelectedLoanPaymentAttachmentID('');
                setViewDetailsOpen(false);
                setIsBulkApisEnabled(false);
                setDisableBtn(false);
                setSelectedRows([]); 
                onSubmit();

              } else {
                toast.error(result.data.message, {
                    position: "top-right",
                });
            }
        }).catch((error) => {
            toast.error(error, {
                position: "top-right",
            });
        });
  }    


   const btnRunENACHBULKTransactions = () => { 
        if(selectedRows.length < 1){
            toast.error("Please select at least one loan record.", {
                position: "top-right",
            });
        }else{
            const confirmed = window.confirm("Are you sure you want to run script?");
            if (confirmed) {
                // Proceed with the action
                console.log("Code is running...");
                setIsBulkApisEnabled(true);
                setDisableBtn(true);
                bulkAllcloudRepayments();
            } else {
                console.log("Action canceled.");
                setIsBulkApisEnabled(false);
                setDisableBtn(false);
            }
        }
    }   

  // Handle Select All
    const handleSelectAll = () => {
      const allIds = allLoanPaymentAttachments.map((row) => row.id);
      setSelectedRows(allIds);
      setRows(rows.map((row) => ({ ...row, bulk_selected: true })));
      console.log(" ckeck all rows = ",rows);
      setDisableBtn(false); 
    };
    
    // Unselect All
    const handleUnselectAll = () => {
      setSelectedRows([]);
      setRows(rows.map((row) => ({ ...row, bulk_selected: false })));
      console.log(" unckeck all rows = ",rows);
      setDisableBtn(false);
    };

  const allTableHead = [
    {
      name: 'S. No.',
      selector: (row, index) => {
        const safeCurrentPage = Number.isInteger(currentPageLeadPage) ? currentPageLeadPage : 1;
        const safeItemsPerPage = Number.isInteger(pageSizeAttachmentPage) ? pageSizeAttachmentPage : 10;
        const rowIndex = (safeCurrentPage - 1) * safeItemsPerPage + index + 1;
        return rowIndex;
      },
      sortable: false,
      width: '70px',  
      style: {
        textAlign: 'center',  
      },
    },
    {
      name: 'Agreement NO',
      selector: (row) => row?.AgreementNo || '-',
      sortable: true,
    },
    {
    name: 'File',
    selector: (row) => row?.file || '-',
    sortable: true,
    cell: (row) =>
      row?.file ? (
        <a
          href={`${row.file}`}
          style={{ textDecoration: 'none', color: 'blue' }}
          target="new"
          rel="noopener noreferrer"
        >
         <i className="nav-icon bi bi-eye">&nbsp;</i>
        </a>
      ) : (
        '-'
      ),
  },
 
 {
      name: 'Created By',
      selector: (row) => row?.createdByName || '-',
      sortable: true,
    },
    {
      name: 'Created ON',
      selector: (row) => row?.created_date || '-',
      sortable: true,
    },

    {
      name: 'Amount',
      selector: (row) => row?.amount || '-',
      sortable: true,
    },

    {
      name: 'Mode Of Payment',
      selector: (row) => row?.mode_of_payment || '-',
      sortable: true,
    },

    {
      name: 'Date Of Payment',
      selector: (row) => row?.formattedDateOfPayment || '-',
      sortable: true,
    },

    {
      name: 'Ledger',
      selector: (row) => row?.ledger_name || '-',
      sortable: true,
    },

     {
      name: 'Instrument No',
      selector: (row) => row?.instrumentNo || '-',
      sortable: true,
    },

    {
    name: 'Enter Payment Details (Maker)',
    selector: row => row?.file || '-',
    sortable: true,
    cell: row => {
      const showDetails = row?.amount?.trim() !== '';
      return (
        <>
          {row?.status !== '1' && (userRoleType === "User" ||  userRoleType === 'Superadmin') && (

            
            <button
              type="button"
              onClick={() => btnViewDetailsHandler(row.id)}
              className="btn btn-link p-0"
              style={{
                color: "green",
                textDecoration: "none",
                float: "right"
              }}
              aria-label="View details"
            >
              <i className="nav-icon bi bi-eye">&nbsp;</i>
            </button>
             
          )}

          {showDetails && (
            <div style={{ whiteSpace: 'normal' }}>  
              Channel: {row.channel}<br />
            </div>
          )}
        </>
      );
    }
  },


  {
    name: 'Make Payment (Checker)',
    selector: row => row?.file || '-',
    sortable: true,
    cell: row => {
       
      return ( 
        <>
          {(row?.status !== '1' && row?.ledger_id !== '') ? (
            <>
            {(userRoleType === "Credit" || userRoleType === 'Superadmin' || userRoleType === 'Credit Operations') && (
               <>
                <div style={{ whiteSpace: 'normal' }}>
                  <input
                    type="checkbox"
                    checked={selectedRows.includes(row.id)}
                    onChange={() => handleCheckboxChange(row.id)}
                 />
                </div>
                 {row?.allCloudPaymentStatus}
               </>
            )}
            </>
          ) : (
            <>
            { row?.status === '1' && (
            <div style={{ whiteSpace: 'normal' }}>
              {row?.allCloudPaymentStatus}
            </div>
            )}
            </>
          )        
        } 
          
        </>
      );
    }
  }
  

  ];

  return (
    <>
      <Helmet>
        <title> Loan Payment Attachments </title>
      </Helmet>
      <div id='main-wrap' className='mb-4 ms-4 me-4'>
        <Typography variant="h4" sx={{ mb: 5 }}>
          Loan Payment Attachments
        </Typography>
        <form onSubmit={handleSubmit(handleFilterChange)}>
          <div id='main-wrap' className='mb-3 filter'>
            <div className='row mx-0'>

              <div className='col'>
                <div className='form-group'>
                  <label htmlFor="start-date">
                    <span>Keyword</span>
                    <input type='text' name='username' className='form-control' {...register('username')} />
                  </label>
                </div>
              </div>

              <div className='col'>
                <div className='form-group'>
                  <label htmlFor="start-date">
                    <span>Start Date</span>
                    <input type='date' name='start_date' className='form-control' {...register('start_date')} />
                  </label>
                </div>
              </div>

              <div className='col'>
                <div className='form-group'>
                  <label htmlFor="end-date">
                    <span>End Date</span>
                    <input type='date' name='end_date' className='form-control' {...register('end_date')} />
                  </label>
                </div>
              </div>

              
              <div className='col'>
                <div className='form-group mb-2'>
                  <span className='d-block'>&nbsp;</span>
                  <button className='btn btn-primary'>Search</button>
                </div>
              </div>
            </div>
          </div>
        </form>
   
        
      </div>

      <Container>
        <div id='main-wrap' className='mb-4'>
          {!excelFileBtnHide ? (
          <div className="col-md-12" style={{ display: 'flex', justifyContent: 'end' }}>
            <div className="col-md-6 text-end" style={{ marginRight: '1rem' }}>
              <div className="form-group mt-2">
                <button className="btn btn-info text-white" onClick={() => exportToExcel()}>Export Excel File</button>
              </div>
            </div>
          </div>
          ) : (
            <p>-</p>
          )}
          <div style={{ width: '100%', overflowY: 'auto' }}>

            {  ( selectedRows.length >0 && !disableBtn ) && (
                <button onClick={btnRunENACHBULKTransactions}
                    type="button"
                    className="btn btn-primary text-white"
                    title="Superadmin and Ajay Grover can schedule multiple transactions within a single month"
                    style={{ position: 'fixed', right:"30px" , zIndex:"99999", top:'130px'}} 
                >
                    Run Allcloud Payment APIs
                </button>
                )}

            {(allLoanPaymentAttachments.length >0) && (
              <div style={{ textAlign: 'right' }}>
                  <button className="btn btn-warning text-white" onClick={handleSelectAll}>Select All</button>&nbsp;
                  
                  <button className="btn btn-danger text-white" onClick={handleUnselectAll}>Unselect All</button>
 
              </div> )}

            <DataTable
              columns={allTableHead}
              data={allLoanPaymentAttachments}
              pagination
              paginationServer
              paginationTotalRows={totalRowsCount}
              paginationPerPage={pageSizeAttachmentPage}
              paginationDefaultPage={currentPageLeadPage}
              onChangePage={handlePageChangeAttachmentPage}
              onChangeRowsPerPage={handlePerRowsChangeAttachmentPage}
            />
          </div>
        </div>
      </Container>

       <Modal
            open={viewDetailsOpen}
            onClose={handleViewDetailsClose}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
        >
            <div className='modal-custom rounded'>
                <div className='modal-head'>
                    <h4 id="modal-title">Details</h4>
                </div>

                <div className='modal-body'>
                    <div className='row mb-2 pb-1'>
                        <div className='col-1'>&nbsp;</div>
                        
                        <div className="col-11 ps-0"> 
                         
                           <form onSubmit={handleSubmit(handlePaymentFormSubmit)} encType="multipart/form-data" ref={formRef}>
                            <div className="row guarantor" id="bank_statement-1">
                              <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label htmlFor="date_of_payment">
                                            <span>Date of Payment <a style={{ color: "red" }}>*</a></span>
                                            <input type='date' id='date_of_payment' 
                                            name='date_of_payment' 
                                             {...register('date_of_payment')}
                                             className='form-control' />
                                        </label>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label htmlFor="amount">
                                            <span>Amount <a style={{ color: "red" }}>*</a></span>
                                            <input type='number' id='amount' 
                                            name='amount' 
                                             {...register('amount')}
                                            className='form-control' />
                                        </label>
                                    </div>
                                </div>

                                
                                  <div className='col-md-6'>
                                      <div className='form-group'>
                                          <label htmlFor="mode_of_payment">
                                              <span>Mode Of Payment <a style={{ color: "red" }}>*</a></span>
                                              <select id='mode_of_payment' 
                                              className="form-select" 
                                              name='mode_of_payment' 
                                              {...register('mode_of_payment')}>
                                                <option value='Bank'>Bank </option> 
                                                <option value='Cash'>Cash </option>
                                                <option value='Transfer'>Transfer </option> 
                                              </select>
                                          </label>
                                      </div>
                                  </div> 

                                  <div className='col-md-6'>
                                      <div className='form-group'>
                                          <label htmlFor="ledger_name">
                                              <span>Ledger <a style={{ color: "red" }}>*</a></span>
                                             <select
                                              id='ledger_name'
                                              name='ledger_name'
                                              className="form-select"
                                              {...register('ledger_name')}
                                              >
                                              <option value="">Please select</option>
                                              {allLedgersArr.length > 0 &&
                                                allLedgersArr.map((option, index) => (
                                                  <option key={`ledger_name-${option.id}`} value={option.ledger_name}>{option.ledger_name}</option>
                                                ))} 
                                              </select>
                                          </label>
                                      </div>
                                  </div> 

                                  <div className='col-md-6'>
                                      <div className='form-group'>
                                          <label htmlFor="channel">
                                              <span>Channel <a style={{ color: "red" }}>*</a></span>
                                             <select
                                              id='channel'
                                              name='channel'
                                              className="form-select"
                                              {...register('channel')}
                                              >
                                              <option value="">Please select</option>
                                              {allChannelArr.length > 0 &&
                                                allChannelArr.map((option, index) => (
                                                  <option key={`channel-${option}`} value={option}>{option}</option>
                                                ))} 
                                              </select>
                                          </label>
                                      </div>
                                  </div> 
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <label htmlFor="instrumentNo">
                                            <span>Instrument No <a style={{ color: "red" }}>*</a></span>
                                            <input type='text' id='instrumentNo' 
                                            name='instrumentNo' 
                                             {...register('instrumentNo')}
                                            className='form-control' />
                                        </label>
                                    </div>
                                </div>

                                  </div>
                                  <div className="row">
                                  <div className="col-md-12">
                                      <div className="form-group mb-0">
                                          <button disabled={props.leadStatusFlag === true} className="btn btn-primary">Submit</button>
                                      </div>
                                  </div>
                                  </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    </>
  );
}

function mapStateToProps(state) {
  return {
    usersData: state.usersData,
    getUserModuleData: state.getUserModuleData,
    masterProfileData: state.masterProfileData,
    getLoggedinUserChild: state.getLoggedinUserChild,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign(leadActions.default, userActions.default, incidentReporteActions.default), dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoanPaymentAttachments);